import Header from './components/Header';
import Main from './components/Main';
import './App.css';
import ContactForm from './components/ContactForm';
import Gallery from './components/Gallery';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
    <Header />
    <Main />
    <ContactUs />
    <ContactForm />
    <Gallery />
    <Footer />
    </div>
  );
}

export default App;
